import { FrameValue, Interpolation } from '@react-spring/web';

export const getNormalizedValueInterpolator = (
  value: FrameValue<number>,
  range: readonly number[],
): Interpolation<number, number> =>
  value.to({
    range: [0, 1],
    output: range,
  });
